import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { updateSupplierQuoteMargin } from '@services/commonService';

import { validateFloatNumber } from '@utils/Util';

const StyleWiseMargin = ({ defaultMargin, quoteId, getAllSupplierQuotes }) => {
	const [value, setValue] = useState('');
	const dispatch = useDispatch();

	useEffect(() => {
		setValue(defaultMargin);
	}, [defaultMargin]);

	const saveMargin = async (e) => {
		try {
			dispatch(openLoader());
			const data = await updateSupplierQuoteMargin(quoteId, e?.target?.value || 0);
			if (!data?.success) {
				setValue('');
			}
			await getAllSupplierQuotes();
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	return (
		<input
			type="number"
			min={1}
			placeholder="$00.00"
			value={value}
			onKeyPress={validateFloatNumber}
			onChange={(e) => setValue(e.target.value)}
			onBlur={saveMargin}
		/>
	);
};

export default StyleWiseMargin;
